import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {};

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

function resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {};

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_restaurants_catalogs';

/**
 * Retrieves catalogs, given the provided filtering, sorting and paging.
 * Note that there is a single catalog per location.
 * @deprecated It has been replaced with com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.ListMenus(), and will be removed on 2025-09-30.
 */
export function listCatalogs(payload: object): RequestOptionsFactory<any> {
  function __listCatalogs({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.CatalogsApi.ListCatalogs',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath: '/v3/catalogs',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload, true),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'catalogs.draftPublishedDate' }],
          },
        ]),
    };

    return metadata;
  }

  return __listCatalogs;
}

/**
 * Retrieves a menu.
 * @deprecated It has been replaced with com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.GetMenu(), and will be removed on 2025-09-30.
 */
export function getMenu(payload: object): RequestOptionsFactory<any> {
  function __getMenu({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'GET' as any,
      methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.GetMenu',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/menus/{menuId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getMenu;
}

/**
 * Retrieves a section.
 * @deprecated It has been replaced with com.wixpress.restaurants.menus_section.v1.RestaurantsMenusSection.GetSection(), and will be removed on 2025-09-30.
 */
export function getSection(payload: object): RequestOptionsFactory<any> {
  function __getSection({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'GET' as any,
      methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.GetSection',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath:
          '/v3/catalogs/{catalogId}/menus/{menuId}/sections/{sectionId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getSection;
}

/**
 * Updates a menu.
 * You can't update archived menus.
 * @deprecated It has been replaced with com.wixpress.restaurants.menus_section.v1.RestaurantsMenusSection.GetSection(), and will be removed on 2025-09-30.
 */
export function updateMenu(payload: object): RequestOptionsFactory<any> {
  function __updateMenu({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'PATCH' as any,
      methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.UpdateMenu',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/menus/{menu.id}',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __updateMenu;
}

/**
 * Updates a section.
 * You can't update archived sections. Note that every section belongs to a single menu, you can't add it to another menu.
 * @deprecated It has been replaced with com.wixpress.restaurants.menus_section.v1.RestaurantsMenusSection.UpdateSection(), and will be removed on 2025-09-30.
 */
export function updateSection(payload: object): RequestOptionsFactory<any> {
  function __updateSection({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'PATCH' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.CatalogsApi.UpdateSection',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath:
          '/v3/catalogs/{catalogId}/menus/{menuId}/sections/{section.id}',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __updateSection;
}

/**
 * Retrieves menus, given the provided filtering, sorting and paging.
 * @deprecated It has been replaced with com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.ListMenus(), and will be removed on 2025-09-30.
 */
export function listMenus(payload: object): RequestOptionsFactory<any> {
  function __listMenus({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fieldMask' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'GET' as any,
      methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.ListMenus',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/menus',
        data: serializedData,
        host,
      }),
      params: toURLSearchParams(serializedData),
    };

    return metadata;
  }

  return __listMenus;
}

/**
 * Retrieves sections, given the provided filtering, sorting and paging.
 * @deprecated It has been replaced with com.wixpress.restaurants.menus_section.v1.RestaurantsMenusSection.ListSections(), and will be removed on 2025-09-30.
 */
export function listSections(payload: object): RequestOptionsFactory<any> {
  function __listSections({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fieldMask' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.CatalogsApi.ListSections',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/sections',
        data: serializedData,
        host,
      }),
      params: toURLSearchParams(serializedData),
    };

    return metadata;
  }

  return __listSections;
}

/**
 * Creates a menu.
 * @deprecated It has been replaced with com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.CreateMenu(), and will be removed on 2025-09-30.
 */
export function createMenu(payload: object): RequestOptionsFactory<any> {
  function __createMenu({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.CreateMenu',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/menus',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __createMenu;
}

/**
 * Archives a menu. You can't update archived menus.
 * @deprecated Will be removed on 2025-09-30.
 */
export function archiveMenu(payload: object): RequestOptionsFactory<any> {
  function __archiveMenu({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.ArchiveMenu',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/menus/{menuId}/archive',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __archiveMenu;
}

/**
 * Unarchives a menu.
 * @deprecated Will be removed on 2025-09-30.
 */
export function unarchiveMenu(payload: object): RequestOptionsFactory<any> {
  function __unarchiveMenu({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.CatalogsApi.UnarchiveMenu',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/menus/{menuId}/unarchive',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __unarchiveMenu;
}

/**
 * Creates a section.
 * You can't add the section to multiple menus, since every section belongs to a single menu.
 * @deprecated It has been replaced with com.wixpress.restaurants.menus_section.v1.RestaurantsMenusSection.CreateSection(), and will be removed on 2025-09-30.
 */
export function createSection(payload: object): RequestOptionsFactory<any> {
  function __createSection({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.CatalogsApi.CreateSection',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/menus/{menuId}/sections',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __createSection;
}

/**
 * Retrieves an item.
 * @deprecated It has been replaced with com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.GetItem(), and will be removed on 2025-09-30.
 */
export function getItem(payload: object): RequestOptionsFactory<any> {
  function __getItem({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'GET' as any,
      methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.GetItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/items/{itemId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getItem;
}

/**
 * Retrieves items, given the provided filtering, sorting and paging.
 * @deprecated It has been replaced with com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.ListItems(), and will be removed on 2025-09-30.
 */
export function listItems(payload: object): RequestOptionsFactory<any> {
  function __listItems({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fieldMask' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'GET' as any,
      methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.ListItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/items',
        data: serializedData,
        host,
      }),
      params: toURLSearchParams(serializedData),
    };

    return metadata;
  }

  return __listItems;
}

/**
 * Updates an item.
 * You can't update archived items.
 * @deprecated It has been replaced with com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.UpdateItem(), and will be removed on 2025-09-30.
 */
export function updateItem(payload: object): RequestOptionsFactory<any> {
  function __updateItem({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'PATCH' as any,
      methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.UpdateItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/items/{item.id}',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __updateItem;
}

/**
 * Creates a dish.
 * @deprecated It has been replaced with com.wixpress.restaurants.menus_item.v1.RestaurantsMenusItem.CreateItem(), and will be removed on 2025-09-30.
 */
export function createDish(payload: object): RequestOptionsFactory<any> {
  function __createDish({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn: 'com.wixpress.restaurants.catalogs.v3.CatalogsApi.CreateDish',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath:
          '/v3/catalogs/{catalogId}/menus/{menuId}/sections/{sectionId}/items',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __createDish;
}

/**
 * Creates a variation.
 * @deprecated It has been replaced with wix.restaurants.menus_item_variant.v1.VariantsService.CreateVariant(), and will be removed on 2025-09-30.
 */
export function createVariation(payload: object): RequestOptionsFactory<any> {
  function __createVariation({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.CatalogsApi.CreateVariation',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3CatalogsApiUrl({
        protoPath: '/v3/catalogs/{catalogId}/variations',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __createVariation;
}

/**
 * Creates a draft version of the specified catalog.
 * Then you can update and publish the draft catalog by using the endpoints in the [Draft Catalogs category](https://dev.wix.com/api/rest/wix-restaurants/catalogs/draft-catalogs).
 *
 * > **Note:** You can't create more than one draft catalog per location.
 * @deprecated Will be removed on 2025-09-30.
 */
export function createDraftCatalog(
  payload: object
): RequestOptionsFactory<any> {
  function __createDraftCatalog({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.CreateDraftCatalog',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
        protoPath: '/v3/draft-catalogs/{catalogId}/create',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'catalog.draftPublishedDate' }],
          },
        ]),
    };

    return metadata;
  }

  return __createDraftCatalog;
}

/**
 * Publishes a draft catalog to the live site by replacing the existing catalog.
 * @deprecated Will be removed on 2025-09-30.
 */
export function publishDraftCatalog(
  payload: object
): RequestOptionsFactory<any> {
  function __publishDraftCatalog({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.PublishDraftCatalog',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
        protoPath: '/v3/draft-catalogs/{catalogId}/publish',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'catalog.draftPublishedDate' }],
          },
        ]),
    };

    return metadata;
  }

  return __publishDraftCatalog;
}

/**
 * Discards a draft catalog. If you want to continue using [Bulk endpoints](https://dev.wix.com/api/rest/wix-restaurants/catalogs/draft-catalogs) for this catalog, you must first call the [Create Draft Catalog](https://dev.wix.com/api/rest/wix-restaurants/catalogs/draft-catalogs/create-draft-catalog) endpoint again.
 * @deprecated Will be removed on 2025-09-30.
 */
export function discardDraftCatalog(
  payload: object
): RequestOptionsFactory<any> {
  function __discardDraftCatalog({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'DELETE' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.DiscardDraftCatalog',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
        protoPath: '/v3/draft-catalogs/{catalogId}/discard',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __discardDraftCatalog;
}

/**
 * Adds multiple variations to a draft catalog.
 * @deprecated Will be removed on 2025-09-30.
 */
export function bulkCreateVariations(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkCreateVariations({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkCreateVariations',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
        protoPath: '/v3/draft-catalogs/{catalogId}/bulk/variations/create',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkCreateVariations;
}

/**
 * Updates multiple items in a draft catalog.
 * You can't update archived items.
 * @deprecated Will be removed on 2025-09-30.
 */
export function bulkUpdateItems(payload: object): RequestOptionsFactory<any> {
  function __bulkUpdateItems({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkUpdateItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
        protoPath: '/v3/draft-catalogs/{catalogId}/bulk/items/update',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkUpdateItems;
}

/**
 * Adds multiple dishes to a draft catalog.
 * @deprecated Will be removed on 2025-09-30.
 */
export function bulkCreateDishes(payload: object): RequestOptionsFactory<any> {
  function __bulkCreateDishes({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkCreateDishes',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
        protoPath: '/v3/draft-catalogs/{catalogId}/bulk/dishes/create',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkCreateDishes;
}

/**
 * Adds multiple menus to a draft catalog.
 * @deprecated Will be removed on 2025-09-30.
 */
export function bulkCreateMenus(payload: object): RequestOptionsFactory<any> {
  function __bulkCreateMenus({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkCreateMenus',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
        protoPath: '/v3/draft-catalogs/{catalogId}/bulk/menus/create',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkCreateMenus;
}

/**
 * Updates multiple menus in a draft catalog.
 * You can't update archived menus.
 * @deprecated Will be removed on 2025-09-30.
 */
export function bulkUpdateMenus(payload: object): RequestOptionsFactory<any> {
  function __bulkUpdateMenus({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkUpdateMenus',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
        protoPath: '/v3/draft-catalogs/{catalogId}/bulk/menus/update',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkUpdateMenus;
}

/**
 * Adds multiple sections to a draft catalog.
 * @deprecated Will be removed on 2025-09-30.
 */
export function bulkCreateSections(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkCreateSections({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkCreateSections',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
        protoPath: '/v3/draft-catalogs/{catalogId}/bulk/sections/create',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkCreateSections;
}

/**
 * Updates multiple sections in a draft catalog.
 * You can't update archived sections.
 * @deprecated Will be removed on 2025-09-30.
 */
export function bulkUpdateSections(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkUpdateSections({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkUpdateSections',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
        protoPath: '/v3/draft-catalogs/{catalogId}/bulk/sections/update',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkUpdateSections;
}

/**
 * Changes the `archived` boolean to `true` for multiple menus in a draft catalog.
 * @deprecated Will be removed on 2025-09-30.
 */
export function bulkArchiveMenus(payload: object): RequestOptionsFactory<any> {
  function __bulkArchiveMenus({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkArchiveMenus',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
        protoPath: '/v3/draft-catalogs/{catalogId}/bulk/menus/archive',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkArchiveMenus;
}

/**
 * Changes the `archived` boolean to `false` for multiple menus in a draft catalog.
 * @deprecated Will be removed on 2025-09-30.
 */
export function bulkUnarchiveMenus(
  payload: object
): RequestOptionsFactory<any> {
  function __bulkUnarchiveMenus({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.catalogs.v3.catalog',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.catalogs.v3.DraftCatalogsApi.BulkUnarchiveMenus',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsCatalogsV3DraftCatalogsApiUrl({
        protoPath: '/v3/draft-catalogs/{catalogId}/bulk/menus/unarchive',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkUnarchiveMenus;
}
